export default __webpack_public_path__ + "static/media/yield-maps.2db9d691.svg";